import { useCallback, useEffect, useState } from 'react';
import { getCategories } from '../services/categories';

export function useCategories(enabled = true) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCategories = useCallback(async () => {
    if (!enabled) {
      setCategories([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const res = await getCategories();
      setCategories(res?.data?.categories || []);
    } catch (e) {
      setError(e?.message || 'Failed to load categories');
      setCategories([]);
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  return { categories, loading, error, refetch: fetchCategories };
}
